import DocumentList from './DocumentsList';

export default DocumentList;
